export let hideHeader = true;

export const setHideHeader = (val: boolean) => {
  hideHeader = val
}